import engine from 'store/src/store-engine'

import sessionStorage from 'store/storages/sessionStorage'
import memoryStorage from 'store/storages/memoryStorage'

// We need a separate sessionStorage store to handle cases
// where information (e.g. sessionId) should not persist
// between browser sessions.
const storage = engine.createStore([
    sessionStorage,
    memoryStorage,
])

export default storage
